import { Injectable } from "@angular/core";
import { ConfigurationModel } from "./configuration";
import { ConfigurationTerrain } from "./terrains";

export class Project{
  id: number;
  name: string;
  description: string;
  editable: boolean = true;
  active: boolean = false;
  selected: boolean;
  configurationID: number ;
  userSettingsJSON : string;


}

export class ProjectUploadModel extends Project{

  zipFile: File
  terrains: ConfigurationTerrain[];

  static mapToFormData(project: ProjectUploadModel): FormData{
    const formData: FormData = new FormData();
    project.id != null? formData.append('id', project.id.toString()): false;
    formData.append('name', project.name);
    formData.append('description', project.description)
    formData.append('editable', JSON.stringify(true))
    project.active != null? formData.append('active', JSON.stringify(project.active)): false;
    project.configurationID != null? formData.append('configurationID', project.configurationID.toString()): false;
    project.zipFile != null? formData.append("zipFile", project.zipFile, project.zipFile.name): false;
    if (project.terrains && project.terrains.length > 0){
      formData.append('terrainsJSON', JSON.stringify(project.terrains))
    }
    return formData;
  }
}
